import { axios, HOST, config } from "./settiing";
export default {
  getTravelDetail(id) {
    return axios.get(`${HOST}/manage/travel/${id}`, config);
  },

  getCanceledTravelList(start, end) {
    return axios.get(`${HOST}/manage/travel/cancel/${start}/${end}`, config);
  },

  getListBetweenDate(start, end) {
    return axios.get(`${HOST}/manage/travel/${start}/${end}`, config);
  },

  getDoneListBetweenDate(start, end) {
    return axios.get(`${HOST}/manage/travel/driving/${start}/${end}`, config);
  },

  getTravelLogByTravelId(travelId) {
    return axios.get(`${HOST}/manage/travel/log/${travelId}`, config);
  },

  getDrivingPath() {
    return axios.get(`${HOST}/manage/drt/drivingPath`, config);
  },

  getDrivingList() {
    return axios.get(`${HOST}/manage/drt/driving`, config);
  },

  getDrivingVehicleLocation(data) {
    return axios.post(`${HOST}/manage/drt/vehicleLocation`, data, config);
  },

  addDriving(data) {
    return axios.post(`${HOST}/manage/driving`, data, config);
  },

  getDrivingScheduleByDate(date) {
    return axios.get(`${HOST}/manage/driving/schedule/${date}`, config);
  },

  getRouteDrivingPath(data) {
    let param = encodeURI(data);
    return axios.get(`${HOST}/maps/routes/${param}`, config);
  },

  addRouteInfo(data) {
    return axios.post(`${HOST}/resource/routeinfo`, data, config);
  },

  getRouteList() {
    return axios.get(`${HOST}/resource/route`, config);
  },

  getRoute(routeId) {
    return axios.get(`${HOST}/resource/route/${routeId}`, config);
  },

  getDrivingBetweenDate(routeId, start, end) {
    return axios.get(
      `${HOST}/manage/driving/${routeId}/${start}/${end}`,
      config
    );
  },

  deleteDriving(data) {
    return axios.post(`${HOST}/manage/driving/delete`, data, config);
  },

  deleteRoutes(data) {
    return axios.post(`${HOST}/resource/route/bulk/remove`, data, config);
  },
};
